import React from 'react';
import { Box, Typography } from '@mui/material';

const fmtCurrency = (v: number) =>
  v.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
const fmtNum = (v: number) => v.toLocaleString('en-US', { maximumFractionDigits: 2 });

interface ActualsSummary {
  totalStaff: number;
  totalHours: number;
  hoursPerCase: number;
  costPerCase: number;
  totalCost: number;
}

interface StaffingSummaryGridProps {
  calculated: {
    totalDirectStaff: number;
    totalClinicalHours: number;
    clinicalHoursPerCase: number;
    costPerCase: number;
    totalCost: number;
  };
  actualsSummary: ActualsSummary | null;
}

const SummaryRow: React.FC<{
  label: string;
  calculated: string;
  actual: string | null;
}> = ({ label, calculated, actual }) => (
  <>
    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.78rem', lineHeight: 1.25 }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 600, textAlign: 'right', fontSize: '0.78rem', lineHeight: 1.25 }}>{calculated}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 600, textAlign: 'right', color: actual ? '#1e293b' : '#cbd5e1', fontSize: '0.78rem', lineHeight: 1.25 }}>
      {actual ?? '—'}
    </Typography>
  </>
);

const StaffingSummaryGrid: React.FC<StaffingSummaryGridProps> = ({ calculated, actualsSummary }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 72px 72px', columnGap: 0.75, rowGap: 0.65, mt: 0.5, mb: 1.25, pt: 0.25 }}>
    <Box />
    <Typography variant="caption" sx={{ fontWeight: 600, color: '#94a3b8', textAlign: 'right', fontSize: '0.68rem' }}>Calculated</Typography>
    <Typography variant="caption" sx={{ fontWeight: 600, color: '#94a3b8', textAlign: 'right', fontSize: '0.68rem' }}>Actual</Typography>

    <SummaryRow label="Total Direct Staff" calculated={fmtNum(calculated.totalDirectStaff)} actual={actualsSummary ? fmtNum(actualsSummary.totalStaff) : null} />
    <SummaryRow label="Clinical Hours" calculated={fmtNum(calculated.totalClinicalHours)} actual={actualsSummary ? fmtNum(actualsSummary.totalHours) : null} />
    <SummaryRow label="Hours / Case" calculated={fmtNum(calculated.clinicalHoursPerCase)} actual={actualsSummary ? fmtNum(actualsSummary.hoursPerCase) : null} />
    <SummaryRow label="Cost / Case" calculated={fmtCurrency(calculated.costPerCase)} actual={actualsSummary ? fmtCurrency(actualsSummary.costPerCase) : null} />
    <SummaryRow label="Total Cost" calculated={fmtCurrency(calculated.totalCost)} actual={actualsSummary ? fmtCurrency(actualsSummary.totalCost) : null} />
  </Box>
);

export default StaffingSummaryGrid;
export type { ActualsSummary };
